import CloseIcon from '@mui/icons-material/Close'
import { Box, Divider, Drawer, IconButton, Typography, useTheme } from '@mui/material'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'

const LeadDrawer = ({ lead, open, onClose }) => {
  console.log('lead', lead)
  const theme = useTheme()
  const { pinned } = useLayoutContext()

  const InfoField = ({ label, value }) => (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 500,
          fontSize: '0.75rem',
          textTransform: 'uppercase',
          letterSpacing: '0.3px',
          display: 'block',
          mb: 0.25,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 500,
          fontSize: '0.9rem',
          wordBreak: 'break-word',
        }}
      >
        {value || '—'}
      </Typography>
    </Box>
  )

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          mt: pinned ? '60px' : 0,
          backgroundColor: theme.palette.background.default,
          backgroundImage: 'none',
        },
      }}
    >
      <Box
        sx={{
          width: { xs: '100vw', sm: '500px', md: '600px' },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.section || theme.palette.background.paper,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: theme.palette.text.primary,
            }}
          >
            Lead Details
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              color: theme.palette.text.secondary,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            p: 2.5,
          }}
        >
          {lead ? (
            <Box>
              {/* Contact Information */}
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: 2,
                  mb: 2,
                }}
              >
                <InfoField label="Name" value={lead.name} />
                <InfoField label="Company" value={lead.company} />
                <InfoField label="Email" value={lead.email} />
                <InfoField label="Phone" value={lead.phone} />
                <InfoField label="Submitted Date" value={lead.submittedDate} />
                <InfoField label="Submitted Time" value={lead.submittedTime} />
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Message Section */}
              {lead.message && (
                <Box>
                  <InfoField label="Message" value={lead.message} />
                </Box>
              )}
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.text.secondary,
                  fontStyle: 'italic',
                }}
              >
                No Lead Selected
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  )
}

export default LeadDrawer
